import {OptionItem} from "./optionItem";
/**
 * Created by strunz on 05.05.2017.
 */
export class Option {

    label: string;
    id: string;
    subItems: OptionItem[] = Array();
    open: boolean = false;
    sort: boolean = true;
    ignore: boolean = false;
    logic: string = 'OR';
    type: string = 'multi';

    constructor(optionData) {
        this.label = optionData.label;
        this.id = optionData.id;
        this.sort = optionData.sort;
        if (optionData.logic) {
            this.logic = optionData.logic;
        }
        if (optionData.type) {
            this.type = optionData.type;
        }
        for (const subItem in optionData.subItems) {
            this.subItems.push(new OptionItem(optionData.subItems[subItem]));
        }
    }

    getAllItems(): OptionItem[] {
        let result: OptionItem[] = new Array();
        for (const subItem in this.subItems) {
            result = this.subItems[subItem].getAllItems(result);
        }
        return result;
    }

    getSelectedItems(): OptionItem[] {
        let result: OptionItem[] = new Array();
        for (const subItem in this.subItems) {
            result = this.subItems[subItem].getSelectedItems(result);
        }
        return result;
    }

    update: any;
}
